import React from 'react';
import { compose, pure } from 'recompose';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { withRouter } from 'react-router';
import { InfoIcon24 } from '@angi/icons/design-system-icons/ui-icons/24';
import './BackgroundCheckBanner.scss';
import { ServiceProviderCacheState } from '../../../../app/types';
import { ONLINE_UPGRADE_OFFER_LOW_COST_TRIAL } from '../../../common/commonConstants';
import { getServiceProviderUpgradeState, PENDING_UPGRADE_STATE } from '../../common/selectors/upgradeStateSelectors';
import type { UpgradeStateType } from '../../common/selectors/upgradeStateSelectors';

type Props = {
  serviceProviderUpgradeState: UpgradeStateType,
  serviceProviderCache: ServiceProviderCacheState;
  router: Object;
};


const BackgroundCheckBanner = ({
  serviceProviderUpgradeState,
  serviceProviderCache,
  router,
}: Props): Node => {
  const serviceProviderId = get(router, 'params.serviceProviderId', '');

  if (serviceProviderUpgradeState !== PENDING_UPGRADE_STATE) return null;

  return (
    <div id="background-check-banner--container">
      <div className="background-check-banner--info-icon">
        <InfoIcon24 />
      </div>
      <p className="background-check-banner-text">
        {get(serviceProviderCache[serviceProviderId], 'onlineUpgradeOffer', '') === ONLINE_UPGRADE_OFFER_LOW_COST_TRIAL ? 'Your 1-month trial will start after your background check approval. Expect an email in 2-7 days.' : 'Your approval is pending: background checks can take 2-7 days.'}
      </p>
    </div>
  );
};

export default (compose(
  connect(state => ({
    serviceProviderUpgradeState: getServiceProviderUpgradeState(state),
    serviceProviderCache: state.serviceProviderCache,
    config: state.config,
  })),
  withRouter,
  pure,
)(BackgroundCheckBanner): any);



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/BackgroundCheckBanner.js